import { capitalize } from "lodash";
import { OBJECTIVE_ATTRIBUTE_TYPE } from "src/consts/objectives";

const STATUS_COLOR_TO_VARIANT = {
  green: "success",
  red: "danger",
  yellow: "warning",
  amber: "warning",
  blue: "primary",
};

const getObjectiveStatusBadge = (objective) => {
  const attributes = objective?.attributes;
  if (!attributes?.length) {
    return null;
  }

  const statusAttr = attributes?.find(
    (attr) => attr.attributeType === OBJECTIVE_ATTRIBUTE_TYPE.STATUS
  );

  if (!statusAttr?.value) {
    return null;
  }

  const statusColorAttr = attributes?.find(
    (attr) => attr.attributeType === OBJECTIVE_ATTRIBUTE_TYPE.STATUS_COLOR
  );

  const colorKey = statusColorAttr?.value?.toLowerCase();
  const variant = STATUS_COLOR_TO_VARIANT[colorKey] || "default";

  return {
    id: OBJECTIVE_ATTRIBUTE_TYPE.STATUS,
    label: capitalize(statusAttr.value),
    color: variant,
  };
};

export default getObjectiveStatusBadge;
